import { z } from 'zod/v4';
import { AttributeValuesDTO } from './attribute/attribute-instance';
import { CIDTO } from './ci';
import { CIAttributeDTO } from './ci-attribute';
import { CITypeDTO } from './ci-type/types';
import { TQLGraphResponseDTO } from '@/entities/srm/tql-query/@x/ci';

export { CIDTO, type CI } from './ci';

export const VariableValueSchemaDTO = z.object({
  // define your actual shape here
});
export type VariableValueSchema = z.infer<typeof VariableValueSchemaDTO>;

export const CIResolvedDTO = CIDTO.extend({
  resolve_data: z
    .object({
      delete_cis: z.array(z.object({ id: z.string() })),
      resolved_ci: CIDTO.optional(),
    })
    .optional(),
  connectedCIS: z.lazy(() => TQLGraphResponseDTO).optional(),
});
export type CIResolved = z.infer<typeof CIResolvedDTO>;
// CIBriefSchema
export const CIBriefSchemaDTO = z.object({
  id: z.uuid(),
  ci_name: z.string().optional(),
});
export type CIBriefSchema = z.infer<typeof CIBriefSchemaDTO>;

// CIDepend
export const CIDependDTO = z.object({
  ci_type_id: z.uuid(),
  link_id: z.string(),
});
export type CIDepend = z.infer<typeof CIDependDTO>;

// CIEnrichSchema
export const CIEnrichSchemaDTO = z.object({
  id: z.uuid(),
  ci_name: z.string().optional(),
  ci_type_id: z.uuid(),
  ci_type: CITypeDTO,
  color: z.string().optional(),
  icon: z.string().optional(),
  plane_ci_status: z.boolean(),
  plane_attribute_status: z.boolean(),
  attribute_values: z.array(CIAttributeDTO).default([]).optional(),
  variable_values: z.array(VariableValueSchemaDTO).default([]).optional(),
  can_enrich: z.boolean(),
});
export type CIEnrichSchema = z.infer<typeof CIEnrichSchemaDTO>;

// CIExtendedDTO
export const CIExtendedDTO = CIDTO.extend({
  attribute_values: z.array(CIAttributeDTO).optional(),
});
export type CIExtended = z.infer<typeof CIExtendedDTO>;

// CIExtendedMapDTO
export const CIExtendedMapDTO = CIDTO.extend({
  attribute_values: AttributeValuesDTO.optional(),
});
export type CIExtendedMap = z.infer<typeof CIExtendedMapDTO>;

// CICreateDTO
export const CICreateDTO = z.object({
  ci_type_name: z.string(),
  linked_cis: z.array(
    z.object({
      link_name: z.string(),
      ci_id: z.uuid(),
    }),
  ),
  attribute_values: z
    .array(CIAttributeDTO.pick({ attribute_name: true, value: true }))
    .optional(),
});
export type CICreate = z.infer<typeof CICreateDTO>;

// CICreateMapDTO
export const CICreateMapDTO = z.object({
  ci_type_name: z.string(),
  linked_cis: z.array(
    z.object({
      link_name: z.string(),
      ci_id: z.string(),
    }),
  ),
  attribute_values: z.record(z.string(), z.any()).optional(),
});
export type CICreateMap = z.infer<typeof CICreateMapDTO>;

// CIUpdateDTO
export const CIUpdateDTO = z.object({
  ci_type_name: z.string(),
  attribute_values: z
    .array(CIAttributeDTO.pick({ attribute_name: true, value: true }))
    .optional(),
});
export type CIUpdate = z.infer<typeof CIUpdateDTO>;

// CIUpdateMapDTO
export const CIUpdateMapDTO = z.object({
  ci_type_name: z.string(),
  attribute_values: z.record(z.string(), z.any()).optional(),
});
export type CIUpdateMap = z.infer<typeof CIUpdateMapDTO>;

// CIEssentialDTO
export const CIActionsDTO = z.object({
  can_enrich: z.boolean(),
  can_edit: z.boolean(),
});
export type CIActions = z.infer<typeof CIActionsDTO>;

export const CIActionsOnlyDTO = z
  .object({
    id: z.uuid(),
  })
  .extend(CIActionsDTO.shape);

export type CIActionsOnly = z.infer<typeof CIActionsOnlyDTO>;

export const CIEssentialDTO = CIExtendedMapDTO.extend(CIActionsDTO.shape);

export type CIEssential = z.infer<typeof CIEssentialDTO>;

/** CanExecuteActionRequest */
export interface CanExecuteActionRequest {
  /**
   * Action Id
   * @format uuid
   */
  action_id: string;
}

/** CanExecuteScriptRequest */
export interface CanExecuteScriptRequest {
  /**
   * Script Id
   * @format uuid
   */
  script_id: string;
}

/** Page[CIBaseSchema] */

/** SummaryCIStatusResponse */
export interface SummaryCIStatusResponse {
  /** Value */
  value: number;
  /** Count */
  count: number;
}